import isEmpty from 'lodash/isEmpty';
import isEmail from 'validator/lib/isEmail';
import { checkEmail } from '../api/api';
import {isValidPhoneNumber} from "libphonenumber-js";
import i18n from '../../../i18n';

export const validate = values => {
    let errors = {};

    validateFirstName(values, errors);
    validateLastName(values, errors);
    validateEmail(values, errors);
    validatePhoneNumber(values, errors);
    validatePassword(values, errors);

    return Object.keys(errors).length ? errors : asyncValidate(values);
};

export const validatePro = values => {
    let errors = {};

    validateAgencyName(values, errors);
    validateFirstName(values, errors);
    validateLastName(values, errors);
    validateEmail(values, errors);
    validatePhoneNumber(values, errors);
    validateBillingName(values, errors);
    validateBillingAddress(values, errors);
    validatePassword(values, errors);

    return Object.keys(errors).length ? errors : asyncValidate(values);
};

const validateAgencyName = (values, errors) => {
    const value = values.agencyName;

    if (isEmpty(value)) {
        return errors.agencyName = i18n.t('account.validation_agency_name');
    }
};

const validateFirstName = (values, errors) => {
    const value = values.firstName;

    if (isEmpty(value)) {
        return errors.firstName = i18n.t('account.validation_first_name');
    }
};

const validateLastName = (values, errors) => {
    const value = values.lastName;

    if (isEmpty(value)) {
        return errors.lastName = i18n.t('account.validation_last_name');
    }
};

const validatePhoneNumber = (values, errors) => {
    const value = values.phoneNumber;

    if (!isEmpty(value) && !isValidPhoneNumber(value)) {
        return errors.phoneNumber = i18n.t('account.validation_phone_not_valid');
    }
    if(isEmpty(value)){
        return errors.phoneNumber = i18n.t('account.validation_phone');
    }
};

const validateEmail = (values, errors) => {
    const email = values.email;

    if (isEmpty(email)) {
        return errors.email = i18n.t('account.validation_email_needed_for_connexion');
    }

    if (!isEmail(email)) {
        return errors.email = i18n.t('account.validation_email_not_valid');
    }
};

const validateBillingName = (values, errors) => {
    const value = values.billingName;

    if (isEmpty(value)) {
        return errors.billingName = i18n.t('account.validation_billing_name');
    }
};

const validateBillingAddress = (values, errors) => {
    const value = values.billingAddress;

    if (isEmpty(value)) {
        return errors.billingAddress = i18n.t('account.validation_billing_address');
    }
};

const validatePassword = (values, errors) => {
    const password = values.password;

    if (isEmpty(password)) {
        return errors.password = i18n.t('account.validation_password');
    }
};

export const asyncValidate = (values, dispatch) => {
    return checkEmail(values.email)
        .then(res => {
            if (!res.ok) {
                return {
                    valid: false
                };
            }

            return res.body;
        })
        .then(json => {
            if (!json.valid) {
                return{ email: i18n.t('account.validation_email_taken') };
            }
            return {}
        });
};

